import {TooltipContentProps} from "recharts";
import {ChartColorType, sortedShipmentTypes} from "../../../store";
import {displayShipmentType} from "../../../api";

const shippingReceiptExitsBarChartColors: ChartColorType = {
    MORNING: '#C62828',     // Klassisches Rot
    LATE_MORNING: '#6A1B9A', // Tiefes Violett
    NOON: '#388E3C',        // Smaragdgrün
    TRACKED: '#EF6C00',     // Kupferorange
    POST: '#0277BD'         // Azurblau
}

function ShippingReceiptExitDetailTooltipContent(o: TooltipContentProps<number | string, string>) {
    const { payload, label } = o;
    const grouped: Record<string, number> = {};

    const total = {
        receipt: 0,
        exit: 0
    }

    payload.forEach(e => {
        const dataKey = (e.dataKey || '') as string
        grouped[dataKey] = e.value
        if (dataKey.startsWith('receipt')) {
            total.receipt = total.receipt + e.value
        }
        if (dataKey.startsWith('exit')) {
            total.exit = total.exit + e.value
        }
    })

    return (
        <div
            className="customized-tooltip-content"
            style={{
                opacity: '0.9',
                backgroundColor: 'var(--bulma-background)',
                border: '1px solid var(--bulma-border)',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 0 10px rgba(0,0,0,0.2)',
            }}
        >
            <table className="table">
                <thead>
                <tr>
                    <th>{`${label}`}</th>
                    <th>Eingänge</th>
                    <th>Ausgänge</th>
                </tr>
                </thead>
                <tbody>
                {sortedShipmentTypes.map(t => (
                    <tr key={t}>
                        <td><strong style={{color: `${shippingReceiptExitsBarChartColors[t]}`}}>{displayShipmentType(t)}</strong></td>
                        <td>{grouped[`receipt_${t}`] || 0}</td>
                        <td>{grouped[`exit_${t}`] || 0}</td>
                    </tr>
                ))}
                <tr style={{
                    boxShadow: 'inset 0px 2px 0px 0px var(--bulma-border)'
                }}>
                    <td><strong>Total</strong></td>
                    <td>{total.receipt}</td>
                    <td>{total.exit}</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

export {
    shippingReceiptExitsBarChartColors,
    ShippingReceiptExitDetailTooltipContent
}
